document.addEventListener('alpine:init', () => {
  function cartItemChangeLink(data = {}) {
    return {
      ...data,

      isLoading: false,

      onClick() {
        if (this.isLoading) return;

        this.$dispatch('cartitemchangestart');
        
        this.isLoading = true;

        var url = new URL(this.$el.href);

        var id = url.searchParams.get('id') || null;

        var line = url.searchParams.get('line') || null;

        var quantity = url.searchParams.get('quantity') || null;

        var updates = url.searchParams.getAll('updates[]') || null;

        var fetchUrl = `${url.pathname}.js`;

        var fetchOptions = {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id,
            line,
            quantity,
            updates,
            sections: ['mini-cart']
          })
        };

        fetch(fetchUrl, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.json();
          })
          .then((res) => {
            this.$dispatch('cartitemchangesuccess', { res });
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.$dispatch('cartitemchangeend');
            this.isLoading = false;
          });
      }
    };
  };

  Alpine.data('cartItemChangeLink', cartItemChangeLink);
});
